import debounce from "lodash.debounce";
import { useEffect, useMemo } from "react";

export type UseDebounceResult = ReturnType<typeof useDebounce>;

export function useDebounce<T extends (...args: unknown[]) => ReturnType<T>>(
	changeHandler: T,
	waitMs: number,
): ReturnType<typeof debounce> {
	const debouncedChangeHandler = useMemo(
		() => debounce(changeHandler, waitMs),
		[changeHandler, waitMs],
	);

	useEffect(() => {
		return () => {
			debouncedChangeHandler.cancel();
		};
	}, [debouncedChangeHandler]);

	return debouncedChangeHandler;
}
